export default "__VITE_ASSET__TA_WlRlE__"